<template>
  <div class="edit-user">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <div class="d-flex align-items-center">
          <h1>Edit Account</h1>
          <div
            v-if="loading"
            class="spinner-border text-primary ml-auto"
            role="status"
            aria-hidden="true"
          ></div>
        </div>
      </div>
    </div>
    <div class="container">
      <form novalidate @submit="checkForm">
        <div class="row">
          <div class="form-group col-md-2">
            <select
              class="form-control"
              :class="{ disabled: loading }"
              id="Title"
              name="Title"
              v-model="user.Title"
              :disabled="loading"
            >
              <option value="error">Title *</option>
              <option
                v-for="title in titles"
                v-bind:key="title.Id"
                v-bind:value="title.Id"
              >
                {{ title.Title }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-5">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="FirstName"
              placeholder="First name *"
              required
              v-model="user.FirstName"
              :disabled="loading"
            />
          </div>
          <div class="form-group col-md-5">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="LastName"
              placeholder="Last name *"
              required
              v-model="user.LastName"
              :disabled="loading"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <input
              type="tel"
              class="form-control"
              :class="{ disabled: loading }"
              id="TelephoneNumber"
              placeholder="Telephone"
              v-model="user.Telephone"
              :disabled="loading"
            />
          </div>
          <div class="form-group col-md-6">
            <input
              type="tel"
              class="form-control"
              :class="{ disabled: loading }"
              id="MobileNumber"
              placeholder="Mobile"
              v-model="user.PhoneNumber"
              :disabled="loading"
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            :class="{ disabled: loading }"
            id="Email"
            name="Email"
            placeholder="Email *"
            required
            v-model="user.Email"
            :disabled="loading"
          />
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="Organisation"
              placeholder="Organisation *"
              required
              v-model="user.Organisation"
              :disabled="loading"
            />
          </div>
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="Position"
              placeholder="Position *"
              required
              v-model="user.Position"
              :disabled="loading"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="BuildingNameOrNumber"
              placeholder="Building name/number"
              v-model="user.BuildingNameOrNumber"
              :disabled="loading"
            />
          </div>
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="Street"
              placeholder="Street"
              v-model="user.Street"
              :disabled="loading"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="City"
              placeholder="City"
              v-model="user.City"
              :disabled="loading"
            />
          </div>
          <div class="form-group col-md-6">
            <input
              type="text"
              class="form-control"
              :class="{ disabled: loading }"
              id="PostCode"
              placeholder="Postcode"
              v-model="user.PostCode"
              :disabled="loading"
            />
          </div>
        </div>

        <div v-if="formErrors.length">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
            v-for="error in formErrors"
            :key="error"
          >
            {{ error }}
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div v-if="editUserErrors.length">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
            v-for="error in editUserErrors"
            :key="error"
          >
            {{ error }}
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div
          v-if="editUserSuccess"
          class="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          Updated user successfully!
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <button v-if="loading" class="btn btn-primay btn-block mb-3" disabled>
          Loading...
        </button>
        <button v-else type="submit" class="btn btn-primary btn-block mb-3">
          Update
        </button>
      </form>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "UserAccount",
  components: {
    MainNav,
    Footer
  },
  mounted() {
    this.$store.dispatch("getUser");
    this.$store.commit("USER_EDIT_SUCCESS", false);
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.getters.editUser;
    },
    editUserErrors() {
      return this.$store.getters.editUserErrors;
    },
    editUserSuccess() {
      return this.$store.getters.editUserSuccess;
    }
  },
  data() {
    return {
      titles: [
        {
          Title: "Mr",
          Id: 0
        },
        {
          Title: "Mrs",
          Id: 1
        },
        {
          Title: "Miss",
          Id: 2
        },
        {
          Title: "Dr",
          Id: 3
        },
        {
          Title: "Ms",
          Id: 4
        },
        {
          Title: "Prof",
          Id: 5
        },
        {
          Title: "Rev",
          Id: 6
        },
        {
          Title: "Lady",
          Id: 7
        },
        {
          Title: "Sir",
          Id: 8
        },
        {
          Title: "Capt",
          Id: 9
        }
      ],
      accountTypes: [
        {
          Id: 0,
          Name: "Needs Validation"
        },
        {
          Id: 1,
          Name: "Non Trusted"
        },
        {
          Id: 2,
          Name: "Trusted"
        },
        {
          Id: 3,
          Name: "SLA"
        }
      ],
      formErrors: [],
      editSuccess: false
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      this.formErrors = [];

      //check required
      let missingInputs = 0;
      for (let formInput of e.target.elements) {
        const value = formInput.value.trim();

        if (
          formInput.nodeName === "INPUT" ||
          formInput.nodeName === "TEXTAREA"
        ) {
          if (formInput.hasAttribute("required")) {
            if (value) {
              formInput.classList.remove("is-invalid");
              formInput.classList.add("is-valid");
            } else {
              formInput.classList.remove("is-valid");
              formInput.classList.add("is-invalid");
              missingInputs++;
            }
          }
        }

        if (formInput.nodeName === "SELECT") {
          if (value === "error") {
            formInput.classList.remove("is-valid");
            formInput.classList.add("is-invalid");
            missingInputs++;
          } else {
            formInput.classList.remove("is-invalid");
            formInput.classList.add("is-valid");
          }
        }
      }

      if (missingInputs > 0) {
        this.formErrors.push(
          "You are missing some required fields, please try again"
        );
      }

      if (this.formErrors.length === 0) {
        this.$store.dispatch("editUser", this.user);
      }
    }
  }
};
</script>
